import React from 'react';

import {Twitter, Discord, Github} from '../../assets';
import styles from './styles.module.scss';
import {socialLinks} from '../../constants/links';

const social = [
  {
    id: '1',
    href: socialLinks.twitter,
    icon: <Twitter />,
  },
  {
    id: '2',
    href: socialLinks.discord,
    icon: <Discord />,
  },
  {
    id: '3',
    href: socialLinks.github,
    icon: <Github />,
  },
];

export const Social = () => {
  return (
    <>
      {social.map((item) => {
        return (
          <a
            key={item.id}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}>
            {item.icon}
          </a>
        );
      })}
    </>
  );
};
